<div [ngSwitch]="board.type">
  <sprint-board-details *ngSwitchCase="boardType.sprint" [board]="board"></sprint-board-details>
  <roadmap-board-detail *ngSwitchCase="boardType.roadmap" [boardId]="board.id" [isNotGuest]="isNotGuest$ | async"></roadmap-board-detail>
  <list-board-details *ngSwitchCase="boardType.list" [board]="board" [isNotGuest]="isNotGuest$ | async"></list-board-details>
  <ng-template ngSwitchDefault>
    <column-list [boardId]="board.id" [boardType]="board.type"></column-list>
  </ng-template>
</div>
